module.exports = __webpack_public_path__ + "img/tg_01 (11).c04350be.jpg";